module.exports = __webpack_public_path__ + "img/59400.20618783.jpg";